import type { ISubscriptionInterval } from '../types/subscription';

/**
 * Return formatted interval string.
 * Data are comming from Stripe.
 *
 * 2 month -> every 2 months
 * 1 month -> monthly
 * 1 year -> annualy
 *
 * @param interval ISubscriptionInterval
 */
export const transformSubscriptionInterval = (
    interval: ISubscriptionInterval
) => {
    const { unit, count } = interval;
    let intervalString = `every ${interval.count} ${interval.unit}s`;

    if (unit === 'day' && count === 1) {
        intervalString = 'daily';
    }

    if (unit === 'week' && count === 1) {
        intervalString = 'weekly';
    }

    if (unit === 'month' && count === 1) {
        intervalString = 'monthly';
    }

    if (unit === 'year' && count === 1) {
        intervalString = 'annualy';
    }

    return intervalString;
};
